import { css } from '@emotion/react'
import { Button, Icon } from 'bold-ui'

interface VisualizarTermoProfissionalButtonProps {
  onClick(): void
  isMobile?: boolean
}

export function VisualizarTermoProfissionalButton(props: Readonly<VisualizarTermoProfissionalButtonProps>) {
  const { onClick, isMobile = false } = props

  return (
    <Button skin='outline' size='small' kind='primary' onClick={onClick} style={isMobile && styles.fullWidth}>
      <Icon icon='fileVisualizationOutline' style={styles.icon} />
      Ver termo de responsabilidade do profissional
    </Button>
  )
}

const styles = {
  icon: css`
    margin-right: 0.5rem;
  `,
  fullWidth: css`
    width: 100%;
  `,
}
